const ReservationStatusNew = {
  AVAILABLE: {
    value: 'AVAILABLE',
    labelKey: '/StockDashboard/New/FilterAvailable',
  },
  RESERVED: {
    value: 'RESERVED',
    labelKey: '/StockDashboard/New/FilterReserved',
  },
  SHOWROOM_BLOKKADE: {
    value: 'SHOWROOM_BLOKKADE',
    labelKey: '/StockDashboard/New/FilterShowroomBlock',
  },
  BLOKKERINGSTERMIJN: {
    value: 'BLOKKERINGSTERMIJN',
    labelKey: '/StockDashboard/New/FilterBlocked',
  },
  SOLD: {
    value: 'SOLD',
    labelKey: '/StockDashboard/New/FilterSold',
  },
}

export default ReservationStatusNew
